import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import CopilotWidget from '../components/CopilotWidget';
const CopilotComponent = () => {
    return (_jsx("div", { className: "copilot-component", children: _jsx(CopilotWidget, { containerId: "copilot-widget-container" }) }));
};
const CopilotPage = () => {
    return (_jsx("div", { className: "page copilot-page", children: _jsx(CopilotComponent, {}) }));
};
export default CopilotPage;
